import axios from "axios";
import { toast } from "react-toastify";

import { SyncPricingFunctionResponseBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const syncPricingFunction = async () => {
  const resp = await api.post<SyncPricingFunctionResponseBodyType>(
    "/v2/organizations/sync-pricing-function",
    {}
  );
  return resp.data;
};

export const useSyncPricingFunction = () => {
  return useMutation<any, Error, any, any>({
    mutationFn: async (
      payload: ApiRequest<SyncPricingFunctionResponseBodyType>
    ) => syncPricingFunction(),
    onError(error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 503) {
          // Do nothing
        } else {
          toast.error(`Something went wrong... ${error.message}`);
        }
      }
    },
  });
};
